"use strict";

var hitsSwiper = [];
document.querySelectorAll('.hits__gallery').forEach(function (item, index) {
  var slider = item.querySelector('.swiper-container');
  hitsSwiper[index] = new Swiper(slider, {
    pagination: false,
    loop: false,
    speed: 1000,
    allowTouchMove: true,
    slidesPerView: 1,
    autoplay: false,
    spaceBetween: 40,
    lazy: {
      loadPrevNext: true
    },
    disableOnInteraction: false,
    waitForTransition: true,
    breakpoints: {
      575: {
        slidesPerView: 'auto'
      }
    }
  });
});